import { render, staticRenderFns } from "./LPGReportTab.vue?vue&type=template&id=20058b5a"
import script from "./LPGReportTab.vue?vue&type=script&lang=js"
export * from "./LPGReportTab.vue?vue&type=script&lang=js"
import style0 from "./LPGReportTab.vue?vue&type=style&index=0&id=20058b5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports